import { render } from "./block-word.vue?vue&type=template&id=40ca434a&ts=true"
import script from "./block-word.vue?vue&type=script&lang=ts"
export * from "./block-word.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__